// src/pages/2fa/RecoveryTokenPage.js
import React from "react";
import RecoveryTokenManager from "./RecoveryTokenManager";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

function RecoveryTokenPage() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <RecoveryTokenManager />
    </DashboardLayout>
  );
}

export default RecoveryTokenPage;
